#import "../fragments/EventCancelProgressFields.graphql"

mutation RetryEventCancel($productId: ID!) {
  retryEventCancel(productId: $productId) {
    ...EventCancelProgressFields
  }
}
